var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row gutter-sm q-mb-lg" }, [
        _c("div", { staticClass: "col-xs-12 col-sm-12 q-mt-lg" }, [
          _c("span", { staticClass: "q-headline text-weight-light" }, [
            _vm._v(_vm._s(_vm.$t("basic_data")))
          ])
        ]),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("q-input", {
              attrs: {
                "float-label": _vm.$t("title"),
                error: _vm.$v.title.$error
              },
              on: { input: _vm.$v.title.$touch },
              model: {
                value: _vm.title,
                callback: function($$v) {
                  _vm.title = $$v
                },
                expression: "title"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("q-input", {
              attrs: {
                "float-label": _vm.$t("sub_title"),
                error: _vm.$v.sub_title.$error
              },
              on: { input: _vm.$v.sub_title.$touch },
              model: {
                value: _vm.sub_title,
                callback: function($$v) {
                  _vm.sub_title = $$v
                },
                expression: "sub_title"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("p", { staticClass: "caption" }, [
              _vm._v(_vm._s(_vm.$t("description")))
            ]),
            _c(
              "q-editor",
              {
                attrs: {
                  toolbar: [
                    ["bold", "italic", "strike", "underline"],
                    ["left", "center", "right", "justify"],
                    ["link", "upload"],
                    [
                      {
                        label: null,
                        icon: "fas fa-font",
                        fixedLabel: true,
                        fixedIcon: true,
                        list: "no-icons",
                        options: [
                          "p",
                          "h1",
                          "h2",
                          "h3",
                          "h4",
                          "h5",
                          "h6",
                          "code"
                        ]
                      },
                      {
                        label: null,
                        icon: "fas fa-text-height",
                        fixedLabel: true,
                        fixedIcon: true,
                        list: "no-icons",
                        options: [
                          "size-1",
                          "size-2",
                          "size-3",
                          "size-4",
                          "size-5",
                          "size-6",
                          "size-7"
                        ]
                      },
                      "removeFormat"
                    ],
                    ["quote", "unordered", "ordered"],
                    ["custom_btn"]
                  ],
                  definitions: {
                    bold: { label: null, icon: "fas fa-bold" },
                    italic: { label: null, icon: "fas fa-italic" },
                    strike: { label: null, icon: "fas fa-strikethrough" },
                    underline: { label: null, icon: "fas fa-underline" },
                    left: { label: null, icon: "fas fa-align-left" },
                    center: { label: null, icon: "fas fa-align-center" },
                    right: { label: null, icon: "fas fa-align-right" },
                    justify: { label: null, icon: "fas fa-align-justify" },
                    link: { label: null, icon: "fas fa-link" },
                    upload: {
                      tip: null,
                      icon: "fas fa-file-image",
                      handler: _vm.insertImg
                    },
                    removeFormat: { label: null, icon: "fas fa-eraser" },
                    quote: { label: null, icon: "fas fa-quote-right" },
                    unordered: { label: null, icon: "fas fa-list-ul" },
                    ordered: { label: null, icon: "fas fa-list-ol" }
                  }
                },
                model: {
                  value: _vm.description,
                  callback: function($$v) {
                    _vm.description = $$v
                  },
                  expression: "description"
                }
              },
              [
                _c("q-btn", {
                  attrs: {
                    slot: "custom_btn",
                    dense: "",
                    flat: "",
                    color: "black",
                    icon: "fal fa-code",
                    label: "HTML"
                  },
                  on: {
                    click: function($event) {
                      _vm.show_html = true
                    }
                  },
                  slot: "custom_btn"
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("q-input", {
              attrs: { "float-label": _vm.$t("campaign_url") },
              model: {
                value: _vm.campaign_url,
                callback: function($$v) {
                  _vm.campaign_url = $$v
                },
                expression: "campaign_url"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("q-datetime", {
              attrs: {
                type: "date",
                "float-label": _vm.$t("start_date"),
                format: "DD/MM/YYYY",
                error: _vm.$v.start_date.$error
              },
              on: { input: _vm.$v.start_date.$touch },
              model: {
                value: _vm.start_date,
                callback: function($$v) {
                  _vm.start_date = $$v
                },
                expression: "start_date"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("q-datetime", {
              attrs: {
                type: "date",
                "float-label": _vm.$t("end_date"),
                format: "DD/MM/YYYY",
                error: _vm.$v.end_date.$error
              },
              on: { input: _vm.$v.end_date.$touch },
              model: {
                value: _vm.end_date,
                callback: function($$v) {
                  _vm.end_date = $$v
                },
                expression: "end_date"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("q-select", {
              attrs: {
                "float-label": _vm.$t("allows_invoice_registration"),
                options: _vm.allow_sells_options
              },
              model: {
                value: _vm.allow_sells,
                callback: function($$v) {
                  _vm.allow_sells = $$v
                },
                expression: "allow_sells"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3" },
          [
            _c("q-input", {
              attrs: {
                type: "number",
                "float-label": _vm.$t("training_kpi_points"),
                error: _vm.$v.training_kpi_points.$error
              },
              on: { input: _vm.$v.training_kpi_points.$touch },
              model: {
                value: _vm.training_kpi_points,
                callback: function($$v) {
                  _vm.training_kpi_points = $$v
                },
                expression: "training_kpi_points"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3" },
          [
            _c("q-input", {
              attrs: {
                type: "number",
                "float-label": _vm.$t("training_non_kpi_points"),
                error: _vm.$v.training_non_kpi_points.$error
              },
              on: { input: _vm.$v.training_non_kpi_points.$touch },
              model: {
                value: _vm.training_non_kpi_points,
                callback: function($$v) {
                  _vm.training_non_kpi_points = $$v
                },
                expression: "training_non_kpi_points"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3" },
          [
            _c("q-input", {
              attrs: {
                type: "number",
                "float-label": _vm.$t("training_special"),
                error: _vm.$v.training_special_points.$error
              },
              on: { input: _vm.$v.training_special_points.$touch },
              model: {
                value: _vm.training_special_points,
                callback: function($$v) {
                  _vm.training_special_points = $$v
                },
                expression: "training_special_points"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3" },
          [
            _c("q-input", {
              attrs: {
                type: "number",
                "float-label": _vm.$t("webinar_points"),
                error: _vm.$v.webinar_points.$error
              },
              on: { input: _vm.$v.webinar_points.$touch },
              model: {
                value: _vm.webinar_points,
                callback: function($$v) {
                  _vm.webinar_points = $$v
                },
                expression: "webinar_points"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("p", { staticClass: "caption" }, [
              _vm._v(_vm._s(_vm.$t("banner_card")))
            ]),
            _c("uploader", {
              attrs: {
                content_type: "images",
                multiple: false,
                cropper: true,
                error: _vm.$v.image.$error
              },
              on: {
                fileUploaded: _vm.imageUploaded,
                input: _vm.$v.image.$touch
              }
            }),
            _vm.image
              ? _c(
                  "p",
                  { staticClass: "q-mt-md file-url" },
                  [
                    _c("q-icon", {
                      attrs: { name: "fal fa-check", color: "positive" }
                    }),
                    _c("a", { attrs: { href: _vm.image, target: "_blank" } }, [
                      _vm._v(" " + _vm._s(_vm.$truncateLink(_vm.image)))
                    ])
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("p", { staticClass: "caption" }, [
              _vm._v(_vm._s(_vm.$t("banner_topo")))
            ]),
            _c("uploader", {
              attrs: {
                content_type: "images",
                multiple: false,
                cropper: true,
                aspect_ratio: 192 / 40,
                aspect_ratio_string: "192/40",
                error: _vm.$v.image_banner.$error
              },
              on: {
                fileUploaded: _vm.imageDesktopUploaded,
                input: _vm.$v.image_banner.$touch
              }
            }),
            _vm.image_banner
              ? _c(
                  "p",
                  { staticClass: "q-mt-md file-url" },
                  [
                    _c("q-icon", {
                      attrs: { name: "fal fa-check", color: "positive" }
                    }),
                    _c(
                      "a",
                      { attrs: { href: _vm.image_banner, target: "_blank" } },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$truncateLink(_vm.image_banner))
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _c(
        "q-tabs",
        {
          staticClass: "shadow-1",
          attrs: { color: "secondary" },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "permissions",
              icon: "fal fa-clipboard-list-check",
              label: _vm.$t("permissions")
            },
            slot: "title"
          }),
          _c(
            "q-tab-pane",
            { staticClass: "q-px-lg q-pb-xl", attrs: { name: "permissions" } },
            [
              _c("div", { staticClass: "row gutter-sm" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c("q-select", {
                      attrs: {
                        options: _vm.areas,
                        "float-label": _vm.$t("areas"),
                        error: _vm.$v.area.$error,
                        multiple: "",
                        chips: ""
                      },
                      on: { input: _vm.$v.area.$touch },
                      model: {
                        value: _vm.area,
                        callback: function($$v) {
                          _vm.area = $$v
                        },
                        expression: "area"
                      }
                    })
                  ],
                  1
                ),
                _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
                  _c("p", { staticClass: "caption" }, [
                    _vm._v(_vm._s(_vm.$t("profiles")))
                  ]),
                  _c(
                    "div",
                    { staticClass: "row gutter-sm" },
                    [
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-12" },
                        [
                          _c("q-checkbox", {
                            attrs: {
                              val: true,
                              label: _vm.$t("all"),
                              disable: _vm.disableData
                            },
                            on: {
                              input: function($event) {
                                return _vm.checkAll()
                              }
                            },
                            model: {
                              value: _vm.all_profiles,
                              callback: function($$v) {
                                _vm.all_profiles = $$v
                              },
                              expression: "all_profiles"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._l(_vm.profiles, function(item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "col-xs-12 col-sm-4",
                            class: _vm.getErrorClass(_vm.$v.profile.$error)
                          },
                          [
                            _c("q-checkbox", {
                              attrs: {
                                "keep-color": "",
                                val: item.value,
                                label: item.label,
                                color: _vm.getErrorColor(_vm.$v.profile.$error)
                              },
                              on: { input: _vm.$v.profile.$touch },
                              model: {
                                value: _vm.profile,
                                callback: function($$v) {
                                  _vm.profile = $$v
                                },
                                expression: "profile"
                              }
                            })
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ])
              ])
            ]
          )
        ],
        1
      ),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "far fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "campaigns" })
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "positive",
                label: _vm.$t("save"),
                icon: "far fa-save",
                disable: _vm.disableWhenFinished
              },
              on: {
                click: function($event) {
                  return _vm.saveData()
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            },
            "no-backdrop-dismiss": "",
            "no-esc-dismiss": ""
          },
          model: {
            value: _vm.show_html,
            callback: function($$v) {
              _vm.show_html = $$v
            },
            expression: "show_html"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_html = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [_vm._v("\n\t\t\t\t\tHTML\n\t\t\t\t")])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("q-input", {
                        attrs: {
                          type: "textarea",
                          rows: "10",
                          "float-label": "HTML"
                        },
                        model: {
                          value: _vm.description,
                          callback: function($$v) {
                            _vm.description = $$v
                          },
                          expression: "description"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "row gutter-sm justify-end q-mt-lg" },
                  [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-3" },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "tertiary",
                            label: _vm.$t("close"),
                            icon: "far fa-ban"
                          },
                          on: {
                            click: function($event) {
                              _vm.show_html = false
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }